<template>
    <div
        :style="getStyles"
        class="flex items-center font-medium truncate"
    >
        {{ getDateInterval }}
    </div>
</template>
<script>
import { getWidgetDateInterval } from '@/helpers/widgetUtils'
import { activeLayoutFontSize } from '@/composables/globalData/useLayouts'

export default {
    props: {
        widget: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        getStyles () {
            return activeLayoutFontSize.value
        },
        getDateInterval () {
            return getWidgetDateInterval(this.widget)
        }
    }
}
</script>
